import { GridImage } from "../../components/PhotoGrid/types";
import {DamageAngle} from "./images/DamageAngle";
import {DamageTop} from "./images/DamageTop";
import {DamageClose} from "./images/DamageClose";
import {DamageWide} from "./images/DamageWide";

export const SAMPLE_PHOTOS = [
  {
    id: "1",
    component: DamageAngle,
    alt: "damage on car from the side",
  },
  {
    id: "2",
    component: DamageTop,
    alt: "damage on car from the top",
  },
  {
    id: "3",
    component: DamageClose,
    alt: "damage on car up close",
  },
  {
    id: "4",
    component: DamageWide,
    alt: "damage on car from a wide angle",
  },
] as GridImage[];

export const FILES_TO_ACCEPT = {
  "image/*": [".png", ".gif", ".jpeg", ".jpg"],
};
